

<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="板块设置"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="板块名称">
          <el-input
            v-model="params.SectionName"
            placeholder="请输入板块名称"
            clearable
          />
        </el-form-item>

        <el-form-item label="所属商家" v-if="$permission.isStore() == false">
          <business-select
            v-model="params.StoreId"
            ref="businessSelect"
          ></business-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          prop="OrderId"
          label="序号"
          align="center"
          width="60"
        />
        <el-table-column
          prop="StoreName"
          label="所属商家"
          v-if="$permission.isStore() == false"
        />
        <el-table-column prop="SectionName" label="板块名称" />
        <el-table-column label="图片" align="center" width="125px">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.PhotoAddress"
              :src="'/api' + row.PhotoAddress"
              style="width: 100px; margin-top: 8px"
            ></el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="LinkAddress" label="链接地址" /> -->
        <!--  <el-table-column prop="State" width="80px" label="状态" align="center">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.State == 1">启用</el-tag>
              <el-tag type="danger" v-else>停用</el-tag>
            </template>
          </el-table-column>-->
        <!-- 平台用户才显示该列$permission.isStore()==true则是门店用户 -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import businessSelect from "@/components/shop/business/select";

export default {
  mixins: [listMixin],
  components: { list,businessSelect },
  data() {
    return {
      api: require("@/api/store/section").default,
      params: {
        SectionName: "",
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>